<template>
  <div>
    <h3>Sign in</h3>
    <form @submit.prevent="submitForm">
      <md-field>
        <label>Your email address</label>
        <md-input v-model="email"></md-input>
      </md-field>
    </form>
    <md-empty-state
      v-if="isEmailSent"
      class="md-secondary"
      md-icon="done"
      md-label="Check your email inbox."
      md-description="A magic link has been sent to your inbox."
    >
    </md-empty-state>
    <md-tooltip md-direction="bottom" v-if="hasEmailAddress"
      >Press Enter key or click on Login.</md-tooltip
    >
  </div>
</template>

<script>
import firebase from "../../../../firebaseConfig";
import { eventBus } from "../../eventbus";

export default {
  name: "Login",
  data: function () {
    return {
      email: null,
      displayName: null,
      isEmailSent: false,
    };
  },
  computed: {
    hasEmailAddress() {
      var isInputValid =
        this.email != null && this.email.length > 2 && this.email.includes("@");

      eventBus.loginEmailValid(isInputValid);

      return isInputValid;
    },
  },
  methods: {
    submitForm: function (isDemoAccount) {
      var self = this;

      var continueDemoUrl = null;
      if (isDemoAccount) {
        let demoUrl = new URLSearchParams(window.location.search);
        demoUrl.delete("apiKey");
        demoUrl.delete("oobCode");
        demoUrl.delete("isSneosAdminDemo");

        // TODO create a fake customer in DB, isSneosAdminDemo = true
        // associate this email to the new customer
        demoUrl.append("isSneosAdminDemo", "true");
        continueDemoUrl =
          window.location.origin +
          window.location.pathname +
          "?" +
          demoUrl.toString();

        console.log("continueDemoUrl", continueDemoUrl);
      }

      // Send login email
      var actionCodeSettings = {
        // The URL to redirect to for sign-in completion. This is also the deep
        // link for mobile redirects. The domain (www.example.com) for this URL
        // must be whitelisted in the Firebase Console.
        url: isDemoAccount ? continueDemoUrl : window.location.href,
        handleCodeInApp: true,
      };

      firebase
        .auth()
        .sendSignInLinkToEmail(this.email, actionCodeSettings)
        .then(function () {
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          window.localStorage.setItem("emailForSignIn", self.email);

          eventBus.newSnackbar(
            "Email has been sent, Check your inbox for the magic link."
          );
          self.isEmailSent = true;
          eventBus.magicLinkSent();
        })
        .catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log("Error while sign in", errorCode, errorMessage);

          eventBus.newSnackbar(
            "Error while signing in. " + errorMessage,
            "login"
          );
        });
    },
  },
  created: function () {
    var self = this;

    eventBus.$on("submit-login-form", function (isDemo) {
      self.submitForm(isDemo);
    });
  },
};
</script>

<style>
</style>